/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { IApprovalFlow, IResponseListApprovalFlows } from "../../../interfaces/approvalFlows";
import { IApprovalFlowStep, IResponseListApprovalFlowSteps } from "../../../interfaces/approvalFlowSteps";
import { IApprovalFlowStepLink, IResponseListApprovalFlowStepLinks } from "../../../interfaces/approvalFlowStepLinks";
import { IEntityCatalogItem } from "../../../interfaces/approvalFlowStepAutomation";

const BASE_FLOWS = "/approval_flows";
const BASE_STEPS = "/approval_flow_steps";
const BASE_LINKS = "/approval_flow_step_links";
const BASE_CATALOG = "/approval_flows/entity_catalog";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listApprovalFlows({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlows>(BASE_FLOWS, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export const createApprovalFlow = async (newApprovalFlow: Partial<IApprovalFlow>) => {
  const { data } = await api.post(BASE_FLOWS, { newApprovalFlow });
  return data;
};

export const updateApprovalFlow = async (id: number, approvalFlow: Partial<IApprovalFlow>) => {
  const { data } = await api.put(`${BASE_FLOWS}/${id}`, { approvalFlow });
  return data;
};

export const deleteApprovalFlow = async (id: number) => {
  const { data } = await api.delete(`${BASE_FLOWS}/${id}`);
  return data;
};

export async function listApprovalFlowSteps({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowSteps>(BASE_STEPS, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export const createApprovalFlowStep = async (newApprovalFlowStep: Partial<IApprovalFlowStep>) => {
  const { data } = await api.post(BASE_STEPS, { newApprovalFlowStep });
  return data;
};

export const updateApprovalFlowStep = async (id: number, approvalFlowStep: Partial<IApprovalFlowStep>) => {
  const { data } = await api.put(`${BASE_STEPS}/${id}`, { approvalFlowStep });
  return data;
};

export const deleteApprovalFlowStep = async (id: number) => {
  const { data } = await api.delete(`${BASE_STEPS}/${id}`);
  return data;
};

export async function listApprovalFlowStepLinks({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowStepLinks>(BASE_LINKS, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export const createApprovalFlowStepLink = async (newApprovalFlowStepLink: Partial<IApprovalFlowStepLink>) => {
  const { data } = await api.post(BASE_LINKS, { newApprovalFlowStepLink });
  return data;
};

export const updateApprovalFlowStepLink = async (id: number, approvalFlowStepLink: Partial<IApprovalFlowStepLink>) => {
  const { data } = await api.put(`${BASE_LINKS}/${id}`, { approvalFlowStepLink });
  return data;
};

export const deleteApprovalFlowStepLink = async (id: number) => {
  const { data } = await api.delete(`${BASE_LINKS}/${id}`);
  return data;
};

export const listEntityCatalog = async (entityType: string): Promise<IEntityCatalogItem[]> => {
  const { data } = await api.get<{ catalog: IEntityCatalogItem[] }>(BASE_CATALOG, {
    params: { entityType },
  });
  return data.catalog ?? [];
};
